import React, { useRef, useCallback } from "react";
import { Table, Pagination, CircularProgress } from "@ann/web-components";
import { Filters } from "../../../../components";
import EmptyUsersList from "../EmptyUsersList";
import { TableWrapper, TableContainer, PaginationWrapper, LoadingContainer } from "./UserTableSection.styled";

const UserTableSection = ({
  selectedItemsCount,
  selectedUserUuids = [],
  onClearSelection,
  tableData,
  headers,
  onSelectionChange,
  currentPage,
  itemsPerPage,
  onItemsPerPageChange,
  onPageChange,
  totalItems,
  totalPages,
  loading,
  onSortChange,
  onOrderChange,
  selectedSortOption,
  orderDirection,
  onSearchChange,
  onRoleChange,
  onGroupChange,
  onStatusChange,
  onRefetchUsers,
  showEmptyState = false,
  onInviteUsers,
}) => {
  const tableRef = useRef(null);

  const handleClearSelection = useCallback(() => {
    // Call deselectAll method from Table component
    if (tableRef.current && typeof tableRef.current.deselectAll === 'function') {
      tableRef.current.deselectAll();
    }
    
    // Call original callback if exists
    if (onClearSelection) {
      onClearSelection();
    }
  }, [onClearSelection]);

  return (
    <TableWrapper>
      <TableContainer>
        <Filters
          selectedItemsCount={selectedItemsCount}
          selectedUserUuids={selectedUserUuids}
          onClearSelection={handleClearSelection}
          onSortChange={onSortChange}
          onOrderChange={onOrderChange}
          selectedSortOption={selectedSortOption}
          orderDirection={orderDirection}
          onSearchChange={onSearchChange}
          onRoleChange={onRoleChange}
          onGroupChange={onGroupChange}
          onStatusChange={onStatusChange}
          loading={loading}
          onRefetchUsers={onRefetchUsers}
        />
        {loading ? (
          <LoadingContainer>
            <CircularProgress size="xl" />
          </LoadingContainer>
        ) : showEmptyState ? (
          <EmptyUsersList onInviteUsers={onInviteUsers} />
        ) : (
          <Table
            ref={tableRef}
            selectable
            data={tableData}
            headers={headers}
            mode="table"
            showActions={false}
            onSelectionChange={onSelectionChange}
          />
        )}
      </TableContainer>
      {!showEmptyState && (
        <PaginationWrapper>
          <Pagination
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={onItemsPerPageChange}
            onPageChange={onPageChange}
            totalItems={totalItems}
            totalPages={totalPages}
            disabled={loading}
          />
        </PaginationWrapper>
      )}
    </TableWrapper>
  );
};

export default UserTableSection;

